import { useCallback } from "react"
import { MarkerType, addEdge } from "@xyflow/react"

/**
 * Manages edge CRUD operations: connect, update, delete.
 */
export default function useEdgeOperations(setEdges, setSelectedNode, selectedEdge, setSelectedEdge) {
  // Handle edge connections when dragging from handles
  const onConnect = useCallback(
    (connection) => {
      const newEdge = {
        ...connection,
        id: `edge_${Date.now()}`,
        type: 'default',
        data: {
          edgeType: 'default',
          animated: false,
          arrowPosition: 'end',
        },
        markerEnd: {
          type: MarkerType.ArrowClosed,
          width: 12,
          height: 12,
          color: '#64748b',
        },
      }
      setEdges((eds) => addEdge(newEdge, eds))
    },
    [setEdges]
  )

  // Handle edge click for selection
  const handleEdgeClick = useCallback((event, edge) => {
    setSelectedEdge(edge)
    setSelectedNode(null)
  }, [setSelectedEdge, setSelectedNode])

  // Handle edge update
  const handleEdgeUpdate = useCallback((edgeId, newData) => {
    setEdges((eds) =>
      eds.map((e) => {
        if (e.id === edgeId) {
          return {
            ...e,
            data: { ...e.data, ...newData.data },
          }
        }
        return e
      })
    )
    setSelectedEdge((current) => {
      if (current?.id === edgeId) {
        return { ...current, data: { ...current.data, ...newData.data } }
      }
      return current
    })
  }, [setEdges, setSelectedEdge])

  // Handle edge delete
  const handleEdgeDelete = useCallback((edgeId) => {
    setEdges((eds) => eds.filter((e) => e.id !== edgeId))
    setSelectedEdge(null)
  }, [setEdges, setSelectedEdge])

  const handleEdgePanelClose = useCallback(() => {
    setSelectedEdge(null)
  }, [setSelectedEdge])

  return {
    onConnect,
    handleEdgeClick,
    handleEdgeUpdate,
    handleEdgeDelete,
    handleEdgePanelClose,
  }
}
